<!-- 订单安全校验loading -->
<template>
  <div class="order-verification-popup">
    <van-overlay
      :show="show"
      :lock-scroll="false"
      class="my-overlay"
      z-index="999"
    >
      <div class="wrapper" @click.stop>
        <div class="ring-box">
          <img
            class="logo"
            src="https://elife-dev.oss-cn-shanghai.aliyuncs.com/20230418/订单安全校验logo&19977&20230418173845.png"
          />
          <span class="loading"></span>
          <div class="txt">订单安全校验中...</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
export default {
  props: [],
  data() {
    return {
      show: false,
    }
  },
  methods: {
    close() {
      this.show = false
    },
    open() {
      this.show = true
    },
    setShow(val) {
      this.show = val
    },

  },

}
</script>
<style lang="less" scoped>
.order-verification-popup {
  position: relative;
  .my-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .wrapper {
    margin: 0 auto;
    width: 220px;
    height: 220px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 10px;
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // justify-content: center;
    position: relative;
    .ring-box {
      position: absolute;
      top: 46%;
      left: 50%;
      transform: translate(-50%, -50%);
      .logo {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .loading {
        display: block;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        box-shadow: 4px 0px #1970f4;
        transform-origin: center center;
        animation: rotate 1s linear infinite;
      }
      .txt {
        margin-top: 40px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
      }
      @keyframes rotate {
        100% {
          transform: rotate(360deg);
        }
      }
    }
  }
}
</style>
